import { render } from "./permissao-cadastrar.vue?vue&type=template&id=d39d6732"
import script from "./permissao-cadastrar.vue?vue&type=script&lang=js"
export * from "./permissao-cadastrar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__